import React from 'react';
import firebase from 'firebase';
import userStore from '../store/UserStore';
import logo from '../logo.png';
import '../App.css';
import StyledFirebaseAuth from 'react-firebaseui/StyledFirebaseAuth';
import { Panel, Label } from 'react-bootstrap';


export default class SkillPage extends React.Component {

  constructor(props){
    super(props);
    let logged = false;
    console.log("loading skill page");
    if (userStore.authed){
      logged = true;
    }
    this.levelRef = firebase.database().ref('/users').child(userStore.uid).child('skills').child(this.props.match.params.sid).child('level');
    this.comments = [];
    this.state = {
      loggedIn: logged,
      users: {},
      uid: userStore.uid,
      user: {name: ''},
      catObj: userStore.getGlobal("catObj"),
      topicObj: userStore.getGlobal("topicObj"),
      topicName: '...',
      cats: [],
      comments: [],
      level: 0,
      newcomment:''
    };
    userStore.registerCallback(this.update.bind(this));
  }

  componentWillUnmount(){
    console.log("unmounting");
    userStore.unregister(this.update.bind(this));
  }

  componentDidMount(){
    if (!this.state.topicObj){
      userStore.fetchGlobals();
    } else {
      this.update();
    }
    firebase.database().ref(`comments`).child(this.props.match.params.sid).on('child_added', snapshot => {
            let commentData = snapshot.val();
            if (!commentData) {
              return;
            }
            this.comments.push(commentData);
            this.setState({comments:this.comments});
        });
  }

  update(){
    let topicObj = userStore.getGlobal("topicObj");
    let catObj = userStore.getGlobal("catObj");
    let topicName = "...";
    let cats = [];
    if (!!topicObj){
      topicName = topicObj[this.props.match.params.sid].name;
      cats = Object.values(topicObj[this.props.match.params.sid].cats);
    }
    console.log(userStore.uid);
    this.levelRef.off('value');
    this.levelRef = firebase.database().ref('/users').child(userStore.uid).child('skills').child(this.props.match.params.sid).child('level');
    this.levelRef.on('value', ss=>{
      let level = ss.val();
      if (!!level){
        console.log(level);
        this.setState({level: level});
      }
    })

    this.setState({
      users: userStore.users,
      loggedIn: userStore.authed,
      catObj: catObj,
      topicObj: topicObj,
      topicName: topicName,
      cats: cats
    });
  }

  setLevel(evt){
    let val = evt.target.value;
    firebase.database().ref('/users').child(userStore.uid).child('skills').child(this.props.match.params.sid).child('level').set(val);
  }

  commentChange(evt){
    let val = evt.target.value;
    this.setState({newcomment: val});
  }

  handleSubmit(evt){
    evt.preventDefault();
    let commentObj = {
      content: this.state.newcomment,
      user: {
        uid: userStore.uid,
        name: userStore.displayName
      },
      timestamp: (new Date()).toISOString()
    };
    let newRef = firebase.database().ref('comments').child(this.props.match.params.sid).push();
    newRef.set(commentObj).then(()=>{
      this.setState({newcomment: ''});
    });
    return false;
  }

  render() {


    return (
      <div className="App">
          <header className="App-header">
            <h1>UD CTF Skills</h1>
            <div className="App-title">{!!userStore.authed && <span>{userStore.displayName}</span>}</div>
          </header>
          {!this.state.loggedIn && <div>
              <p>Please sign-in:</p>
              <StyledFirebaseAuth uiConfig={this.uiConfig} firebaseAuth={firebase.auth()}/>
          </div>}
          <section className="skill-header">
            <h2>Skill: {this.state.topicName}</h2>
            <h3>{this.state.cats.map(catname=>{
              return (<Label style={{marginRight: "1em"}} key={catname}>{catname}</Label>);
            })}</h3>
          </section>
          <hr/>
          <section className="skill-report">
            <h3>Your Self-Reported Proficiency: {this.state.level} / 10</h3>
            <input type="number" min="0" max="10" step="1" onChange={this.setLevel.bind(this)} value={this.state.level}/>
          </section>
          <hr/>
          <section className="comment-box">
            <h3>Links, Comments, Etc.</h3>
            <form className="comment-form" onSubmit={this.handleSubmit.bind(this)}>
              <input type="text" value={this.state.newcomment} onChange={this.commentChange.bind(this)} style={{width:"60%"}} placeholder="Add Resources Here"/>
              <button type="submit">Submit</button>
            </form>
            {this.state.comments.map(comment=>{
              return (
                <Panel bsStyle="primary" key={comment.content} className="comment-box" style={{margin: "auto", marginTop:"1em", width:"60%"}}>
                  <Panel.Heading>
                    <Panel.Title componentClass="h3" style={{marginBottom:"1em"}}><span className="left" style={{float:"left"}}>{comment.user.name}</span><span className="right" style={{float:"right"}}>{comment.timestamp}</span></Panel.Title>
                  </Panel.Heading>
                  <Panel.Body>{comment.content}</Panel.Body>
                </Panel>);
            })}
          </section>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/SkillPage.js